function getPropertyValue(element, property) {
    const computedStyles = window.getComputedStyle(element);
    return computedStyles.getPropertyValue(property).trim();
}
function getRootValue(property) {
    const root = document.querySelector(':root');
    const computedStyles = getComputedStyle(root);
    return computedStyles.getPropertyValue(property).trim();
}
function setRootValue(variable, newVal) {
    const root = document.querySelector(':root');
    if (getRootValue(variable) !== newVal) {
        root.style.setProperty(variable, newVal);
    }
}
function noFOUC() {
    document.documentElement.className = 'no-fouc';
    if (document.readyState === 'complete') {
        document.documentElement.classList.remove('no-fouc');
    }
    document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
            document.documentElement.classList.remove('no-fouc');
        }
    };
}
export { getPropertyValue, getRootValue, setRootValue, noFOUC };
